// frontend/src/components/Footer.js
import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>© {new Date().getFullYear()} Unfamiliar Learning. All rights reserved.</p>
            <a href="https://www.unfamiliargroup.com" target="_blank" rel="noopener noreferrer">
                Visit Unfamiliar Group
            </a>
        </footer>
    );
};

export default Footer;